import { ReactElement } from 'react';
import { Price } from '@client/product/components/ProductData/PriceList/Price';
import { Props } from './SecondaryPrices.types';

export const SecondaryPrices = ({ prices }: Props): ReactElement | null=> {
  if (Object.keys(prices).length > 1) {
    return (
      <div className='PriceList-SecondaryPrices'>
        <Price
          price={prices.userPrice.price}
          tax={prices.userPrice.tax}
          dataAttributes={{ 'data-testid': 'pdpPPInclVAT' }}
          isSecondary
        />

        <Price
          price={prices.listPriceWithoutVat.price}
          tax={prices.listPriceWithoutVat.tax}
          dataAttributes={{ 'data-testid': 'pdpSRPExclVAT' }}
          isSecondary
        />

        <Price
          price={prices.listPrice.price}
          tax={prices.listPrice.tax}
          dataAttributes={{ 'data-testid': 'pdpSRPInclVAT' }}
          isSecondary
        />
      </div>
    );
  }

  return null;
};
